/**
* @see /client/components/RestaurantDeals/index.js
* @see /client/components/GiftCardList/index.js @removed
* @see /client/containers/HomePage/SegmentCarousel.js
* @see /client/containers/GiftCard/index.js
* GiftLandingCard
*/

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import { string, bool, array, func, number, oneOfType } from 'prop-types';
import Button from '../../components/Button';
import NoImage from '../../assets/images/no-image-320x200.jpg';
import { utils } from '../../devUtils';

const CardGift = styled.div`
    cursor: pointer;
    text-align: left;
    margin-bottom: 0px;
    display: inline-block;
    padding: 10px;
    margin-bottom:20px;
    border-radius:5px;
    max-width: 100%;
    width: 100%;
  .h-300{
    height: 300px;
  }
  .h-250{
    height: 300px;
  }
  img{
    max-width: 100%;
    width:100%;
    border-radius:10px;
    height:140px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          height:120px;
    };
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      height: auto;
      width: auto;
    };
    &.manipal-img{
      object-fit: contain;
    }
  }
  div {
    padding: 5px 10px;
    text-align:center;
    height: 60px;
    img {
      max-width: 100%;
      border-radius:5px;
    }
    span {
      color: ${(props) => props.theme.secondaryColor};
      font-weight:600;
      font-size:13px;
      b{
        color: ${(props) => props.theme.primaryColor};
        font-weight:700;
        font-size:13px;
        &:after{
          content:'';
          margin:0px 10px;
          // border-right:#333 solid 1px;
          height: 13px;
          display: inline-block;
        }
      }
    }
    strong{
      font-size:13px;
      color:${(props) => props.theme.secondaryColor};
      font-weight:700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      width: 100%;
    }
  }
  select{
      float:left;
      padding:6px;
      border:${(props) => props.theme.lightGray} solid 1px;
      background: ${(props) => props.theme.lightWhite};
      width:47%;
      margin-right:6%;
      font-size:13px;
    }
    ${Button}{
      float:left;
      width:47%;
      margin:0px;
      font-size:12px;
      padding: 8px 4px;
    }
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      height: auto !important;
      text-align: center;
    };
    ${({ padding }) => padding && `padding: ${padding}`}
    ${({ border }) => border && `border: ${border}`}
`;

const GetRupeeSymbol = (amount = {}, otherData = {}) => {
  // if (isOnlyMerchandise) {
  //   return <Fragment>&nbsp;{amount.name}</Fragment>;
  // }
  const { currency_symbol } = otherData;
  if (currency_symbol) {
    return `${currency_symbol} ${amount.name}`;
  }
  return amount.name;
};
/**
 * @todo: venkatesh remove hardcode from utils
 * @todo: move the @func onAddToCartClick to the wrapper tag
 * @argument discountText_discounts_percent_pg_discount_pc are from three different API
 * @param {object} props
 */
function GiftLandingCard(props) {
  const {
    product_type,
    image,
    title,
    name,
    discountText,
    discounts_percent,
    amounts,
    padding,
    border,
    onChildEvents,
    slug,
    isButtonShow,
    isDiscountShow,
    images,
    pg_discount_pc,
    id,
    cardType = null,
    is_free_field = false,
    currency_symbol,
    isMobileWindow = false,
  } = props;
  const _image = image || (images && images.length && images[0].url);
  const onHoverFullImage = <img src={_image || NoImage} alt={title} role="presentation" style={{ width: '400px' }} />;
  return (
    <CardGift padding={padding} key={image + discountText} border={border} className={product_type === 'merchandise' ? 'h-300' : 'h-250'}>
      {isMobileWindow ?
        <img src={_image || NoImage} alt={title} onClick={() => onChildEvents('detailsPage', slug || name, cardType, id || 'image')} role="presentation" /> :
        <Popover content={onHoverFullImage} placement="left" >
          <img src={_image || NoImage} alt={title} onClick={() => onChildEvents('detailsPage', slug || name, cardType, id || 'image')} role="presentation" className={product_type === 'merchandise' ? 'manipal-img' : ''} />
        </Popover>}
      <div>
        <strong onClick={() => onChildEvents('detailsPage', slug, cardType, id || 'title')} role="presentation">{title || name}</strong>
        {isDiscountShow && (discountText || discounts_percent || pg_discount_pc) ?
          <span><b>{discountText || discounts_percent || pg_discount_pc} % Off</b></span> : ''}
      </div>
      {isButtonShow && amounts && amounts.length && product_type !== 'merchandise' ?
        (
          <select
            defaultValue=""
            onChange={(e) => onChildEvents('variationChange', { variation_id: e.target.value, product_id: amounts[0].product_id }, slug || name)}
          >
            <option value="" disabled>Select Value</option>
            {amounts.map((amount) => (
              <option
                key={amount.product_variation_id}
                value={amount.product_variation_id}
              >
                {GetRupeeSymbol(amount, { currency_symbol })}
              </option>
            ))}
          </select>) : ''}
      {product_type === 'merchandise' ?
        <Fragment>
          <div className="text-center" style={{ height: 'auto' }} >
            <span>Price: &#8377;&nbsp;{amounts && amounts.length && utils.convertCentsToAmout(amounts[0].price_cents)}</span>
          </div>
          <div className="text-center" style={{ height: 'auto' }}>
            <Button type="primary" style={{ float: 'none' }} onClick={() => onChildEvents('detailsPage', slug || name, cardType, id || 'image')}>View Product</Button>
          </div>
        </Fragment>
        : null}
      {isButtonShow && product_type !== 'merchandise' && !is_free_field ?
        <Button type="primary" onClick={() => onChildEvents('addToCart', { product_id: amounts[0].product_id }, slug || name)}>Add to Cart</Button>
        : null}
    </CardGift>
  );
}

GiftLandingCard.defaultProps = {
  amounts: [],
  isButtonShow: false,
  is_free_field: false,
  onChildEvents: () => '',
  isDiscountShow: true,
  product_type: '',
  discountText: '',
  image: '',
  pg_discount_pc: 0,
  discounts_percent: 0,
  name: '',
  cardType: '',
  id: '',
  images: [],
  padding: '',
  border: '',
  title: '',
};

GiftLandingCard.propTypes = {
  isButtonShow: bool,
  isDiscountShow: bool,
  is_free_field: bool,
  isMobileWindow: bool.isRequired,
  product_type: string,
  title: string,
  slug: string.isRequired,
  amounts: array,
  discountText: oneOfType([
    string,
    number,
  ]),
  padding: string,
  border: string,
  onChildEvents: func,
  name: string,
  image: string,
  discounts_percent: number,
  images: array,
  pg_discount_pc: number,
  id: string,
  cardType: string,
  currency_symbol: string,
};

export default GiftLandingCard;



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/GiftLandingCard.js